module.exports = __webpack_public_path__ + "img/campaign-headline-mb.a3fa8ec.svg";